<p class="disclaimer-text">{{ disclaimerMessage }}</p>

<div class="faq-container">
  <mat-accordion>
    <mat-expansion-panel>
      <mat-expansion-panel-header class="faq-header" data-test="cost-calc-explanation-header">
        <mat-panel-title>
          How did you calculate this cost?
        </mat-panel-title>
      </mat-expansion-panel-header>

      <ng-container *ngFor="let explantionStr of costCalcExplanation">
        <p [innerHTML]="explantionStr" data-test="cost-calc-explanation-content"></p>
      </ng-container>
    </mat-expansion-panel>

    <mat-expansion-panel *ngIf="showInitialSessionCostFAQ">
      <mat-expansion-panel-header class="faq-header" data-test="initial-session-cost-faq-header">
        <mat-panel-title>
          Why do initial sessions cost more than ongoing sessions?
        </mat-panel-title>
      </mat-expansion-panel-header>

      <ng-container>
        <p data-test="initial-session-cost-faq-content">
          If you are seeing this cost estimate when scheduling your first session with a therapist, 
          be aware that initial sessions, also called “intakes,” may cost more than regular, ongoing sessions. 
          This is because they involve a comprehensive assessment to understand your history and needs, 
          as well as the development of a tailored treatment plan. There is also additional paperwork a therapist 
          must complete outside of your session. All of these factors contribute to a higher fee for first sessions. 
          This initial investment lays the groundwork for successful therapy moving forward.
        </p>
      </ng-container>
    </mat-expansion-panel>

    <mat-expansion-panel *ngIf="showInsuranceTermsFAQ">
      <mat-expansion-panel-header class="faq-header" data-test="insurance-terms-faq-header">
        <mat-panel-title>
          What do these health insurance terms mean?
        </mat-panel-title>
      </mat-expansion-panel-header>

      <ng-container *ngFor="let termDef of insuranceTermDefinitions">
        <p data-test="insurance-terms-faq-content">
          <strong>{{ termDef.term }}: </strong>
          {{ termDef.definition }}
        </p>
      </ng-container>
    </mat-expansion-panel>
  </mat-accordion>
</div>
